// extracted by mini-css-extract-plugin
export default {"flavors_title":"c3","no_selected_flavors":"e3","success":"f3","select_flavors_wrapper":"g3","flavors_select":"h3","custom_select_control":"i3","opened":"j3","subtitle":"k3","selected_flavors":"l3","selected_flavor_item":"m3","selected_flavor_item_image":"n3","selected_flavor_item_title":"o3","selected_flavor_item_qty":"p3","drawer_header":"q3"};
    if(module.hot) {
      // 1713809679985
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  